// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2edcff728ed1d853a1470fd9654c7686861079b1.chunk.bundle.js";
};